import { Action } from '@ngrx/store';

export enum LoaderActionTypes {
    ShowSpinner = '[UI] Show loading spinner',
    HideSpinner = '[UI] Hide loading spinner',
    ForceHideSpinner = '[UI] Force hide loading spinner'
}

export class ShowSpinner implements Action {
    readonly type = LoaderActionTypes.ShowSpinner;
    constructor(public payload?: Action & { showLoader?: boolean }) { }
}
export class HideSpinner implements Action {
    readonly type = LoaderActionTypes.HideSpinner;
    constructor(public payload?: Action & { triggerAction?: string }) { }
}

export class ForceHideSpinner implements Action {
    readonly type = LoaderActionTypes.ForceHideSpinner;
}

export type LoaderActions = ShowSpinner | HideSpinner | ForceHideSpinner;
